// Explorers & Adventurous Souls Data - Group Four (Fourth 6 Characters)

// Marco Polo's workout programs
const marcoPoloPrograms = [
    {
        id: 'silk-road-endurance-training',
        name: 'Silk Road Endurance Training',
        description: 'Epic journey conditioning for 24-year expeditions across hostile territories and unknown lands',
        pattern: 'auypjz',
        reps: 24,
        sets: 17,
        focus: 'Journey Endurance'
    },
    {
        id: 'venetian-merchant-conditioning',
        name: 'Venetian Merchant Conditioning',
        description: 'Trading post strength that builds bridges between East and West through commercial courage',
        pattern: 'pzyauj',
        reps: 125,
        sets: 4,
        focus: 'Commercial Courage'
    },
    {
        id: 'kublai-khan-court-workout',
        name: 'Kublai Khan Court Workout',
        description: 'Imperial court conditioning that earns the respect of the world\'s most powerful emperor',
        pattern: 'yjuzpa',
        reps: 69,
        sets: 3,
        focus: 'Imperial Respect'
    },
    {
        id: 'travels-of-marco-polo-protocol',
        name: 'Travels of Marco Polo Protocol',
        description: 'Storytelling strength that opens European minds to the wonders of the Eastern world',
        pattern: 'zpauyj',
        reps: 129,
        sets: 2,
        focus: 'Wonder Sharing'
    },
    {
        id: 'east-west-bridge-training',
        name: 'East West Bridge Training',
        description: 'Cultural fusion conditioning that connects civilizations separated by vast distances',
        pattern: 'ujypaz',
        reps: 54,
        sets: 4,
        focus: 'Cultural Bridge'
    },
    {
        id: 'legendary-explorer-mastery',
        name: 'Legendary Explorer Mastery',
        description: 'The complete training system that opened the first pathway between Europe and Asia',
        pattern: 'auypjz!',
        reps: 66,
        sets: 3,
        focus: 'Pathway Pioneer'
    }
];

// Christopher Columbus's workout programs
const christopherColumbusPrograms = [
    {
        id: 'ocean-crossing-conditioning',
        name: 'Ocean Crossing Conditioning',
        description: 'Atlantic voyage training that sails into the terrifying unknown with unwavering determination',
        pattern: 'flwtqn',
        reps: 149,
        sets: 2,
        focus: 'Ocean Determination'
    },
    {
        id: 'new-world-discovery-workout',
        name: 'New World Discovery Workout',
        description: 'Continental revelation conditioning that changes the entire map of human possibility',
        pattern: 'nqwtlf',
        reps: 34,
        sets: 10,
        focus: 'World Changing'
    },
    {
        id: 'santa-maria-navigation-training',
        name: 'Santa Maria Navigation Training',
        description: 'Ship command conditioning that leads three vessels across uncharted waters to destiny',
        pattern: 'wtlfnq',
        reps: 70,
        sets: 3,
        focus: 'Navigation Command'
    },
    {
        id: 'isabella-patron-protocol',
        name: 'Isabella Patron Protocol',
        description: 'Royal persuasion training that convinces monarchs to fund impossible expeditions',
        pattern: 'lfnqwt',
        reps: 146,
        sets: 1,
        focus: 'Royal Persuasion'
    },
    {
        id: 'admiral-of-ocean-sea-training',
        name: 'Admiral of Ocean Sea Training',
        description: 'Oceanic mastery conditioning that earns supreme command over all newly discovered waters',
        pattern: 'qwtfln',
        reps: 50,
        sets: 4,
        focus: 'Oceanic Mastery'
    },
    {
        id: 'world-discoverer-mastery',
        name: 'World Discoverer Mastery',
        description: 'The complete training system that revealed an entire hemisphere to European civilization',
        pattern: 'flwtqn!',
        reps: 50,
        sets: 4,
        focus: 'Hemispheric Discovery'
    }
];

// Lewis & Clark's workout programs
const lewisClarkPrograms = [
    {
        id: 'corps-of-discovery-conditioning',
        name: 'Corps of Discovery Conditioning',
        description: 'Expedition leadership training for mapping the unknown American wilderness frontier',
        pattern: 'vgqynu',
        reps: 60,
        sets: 3,
        focus: 'Expedition Leadership'
    },
    {
        id: 'louisiana-purchase-workout',
        name: 'Louisiana Purchase Workout',
        description: 'Territory exploration conditioning that surveys millions of acres of virgin wilderness',
        pattern: 'nuyvgq',
        reps: 128,
        sets: 2,
        focus: 'Territory Survey'
    },
    {
        id: 'sacagawea-guide-training',
        name: 'Sacagawea Guide Training',
        description: 'Native partnership conditioning that builds trust across cultural divides in hostile terrain',
        pattern: 'yqgvnu',
        reps: 45,
        sets: 5,
        focus: 'Cultural Partnership'
    },
    {
        id: 'pacific-ocean-protocol',
        name: 'Pacific Ocean Protocol',
        description: 'Continental crossing training that reaches the western ocean through sheer perseverance',
        pattern: 'gvnuyq',
        reps: 60,
        sets: 3,
        focus: 'Continental Crossing'
    },
    {
        id: 'manifest-destiny-training',
        name: 'Manifest Destiny Training',
        description: 'National expansion conditioning that fulfills America\'s continental ambitions',
        pattern: 'vnqygu',
        reps: 40,
        sets: 6,
        focus: 'National Expansion'
    },
    {
        id: 'american-pathfinder-mastery',
        name: 'American Pathfinder Mastery',
        description: 'The complete training system that opened the American West to settlement and progress',
        pattern: 'vgqynu!',
        reps: 60,
        sets: 3,
        focus: 'Western Pathfinding'
    }
];

// Ernest Shackleton's workout programs
const ernestShackletonPrograms = [
    {
        id: 'endurance-antarctic-conditioning',
        name: 'Endurance Antarctic Conditioning',
        description: 'Ice-locked survival training that maintains hope and leadership in impossible circumstances',
        pattern: 'bgkdwe',
        reps: 22,
        sets: 27,
        focus: 'Ice Survival'
    },
    {
        id: 'elephant-island-workout',
        name: 'Elephant Island Workout',
        description: 'Desolate island conditioning that keeps crews alive on barren rocks in freezing waters',
        pattern: 'wekdbg',
        reps: 165,
        sets: 1,
        focus: 'Desolate Survival'
    },
    {
        id: 'james-caird-boat-training',
        name: 'James Caird Boat Training',
        description: 'Open boat conditioning for 800-mile journeys across the world\'s most dangerous waters',
        pattern: 'kdgweb',
        reps: 80,
        sets: 2,
        focus: 'Open Sea Navigation'
    },
    {
        id: 'south-georgia-rescue-protocol',
        name: 'South Georgia Rescue Protocol',
        description: 'Mountain crossing training over uncharted peaks to save stranded expedition members',
        pattern: 'debgkw',
        reps: 36,
        sets: 5,
        focus: 'Rescue Leadership'
    },
    {
        id: 'heroic-age-training',
        name: 'Heroic Age Training',
        description: 'Polar exploration conditioning that defines the golden age of Antarctic adventure',
        pattern: 'gbwedk',
        reps: 191,
        sets: 1,
        focus: 'Polar Heroism'
    },
    {
        id: 'greatest-leader-mastery',
        name: 'Greatest Leader Mastery',
        description: 'The complete training system that brought every crew member home against impossible odds',
        pattern: 'bgkdwe!',
        reps: 59,
        sets: 3,
        focus: 'Ultimate Leadership'
    }
];

// Amelia Earhart's workout programs
const ameliaEarhartPrograms = [
    {
        id: 'aviation-pioneer-conditioning',
        name: 'Aviation Pioneer Conditioning',
        description: 'Flying machine training that soars above traditional limitations and gender barriers',
        pattern: 'hrmiaf',
        reps: 127,
        sets: 1,
        focus: 'Aviation Pioneer'
    },
    {
        id: 'atlantic-solo-flight-workout',
        name: 'Atlantic Solo Flight Workout',
        description: 'Transatlantic conditioning that crosses oceans alone in primitive flying machines',
        pattern: 'aifmrh',
        reps: 15,
        sets: 20,
        focus: 'Solo Ocean Flight'
    },
    {
        id: 'ninety-nines-training',
        name: 'Ninety Nines Training',
        description: 'Female aviator conditioning that organizes women pilots into a powerful sisterhood',
        pattern: 'mrhifa',
        reps: 99,
        sets: 2,
        focus: 'Female Aviation'
    },
    {
        id: 'around-world-flight-protocol',
        name: 'Around World Flight Protocol',
        description: 'Global circumnavigation training that attempts to fly around the entire planet',
        pattern: 'ifahrm',
        reps: 290,
        sets: 2,
        focus: 'Global Flight'
    },
    {
        id: 'powder-puff-derby-training',
        name: 'Powder Puff Derby Training',
        description: 'Air racing conditioning that proves women can compete with men in aerial competition',
        pattern: 'fhrmia',
        reps: 39,
        sets: 5,
        focus: 'Air Racing'
    },
    {
        id: 'sky-goddess-mastery',
        name: 'Sky Goddess Mastery',
        description: 'The complete training system that inspired generations of women to reach for the heavens',
        pattern: 'hrmiaf!',
        reps: 39,
        sets: 5,
        focus: 'Heavenly Inspiration'
    }
];

// Wild Bill Hickok's workout programs
const wildBillHickokPrograms = [
    {
        id: 'quick-draw-gunfighter-training',
        name: 'Quick Draw Gunfighter Training',
        description: 'Lightning reflex conditioning that outdaws the fastest guns in the American frontier',
        pattern: 'xcskpb',
        reps: 36,
        sets: 6,
        focus: 'Lightning Reflexes'
    },
    {
        id: 'deadwood-lawman-conditioning',
        name: 'Deadwood Lawman Conditioning',
        description: 'Frontier justice training that brings order to the wildest towns in the American West',
        pattern: 'bpscxk',
        reps: 187,
        sets: 1,
        focus: 'Frontier Justice'
    },
    {
        id: 'aces-and-eights-workout',
        name: 'Aces and Eights Workout',
        description: 'Gambling strength training that plays poker with death and destiny in saloon showdowns',
        pattern: 'skxcbp',
        reps: 88,
        sets: 2,
        focus: 'Gambling Courage'
    },
    {
        id: 'buffalo-bill-show-protocol',
        name: 'Buffalo Bill Show Protocol',
        description: 'Wild West exhibition conditioning that performs legendary skills before amazed audiences',
        pattern: 'cpbxsk',
        reps: 31,
        sets: 6,
        focus: 'Exhibition Skills'
    },
    {
        id: 'prairie-scout-training',
        name: 'Prairie Scout Training',
        description: 'Frontier survival conditioning that tracks enemies across vast wilderness expanses',
        pattern: 'kscpbx',
        reps: 42,
        sets: 4,
        focus: 'Wilderness Tracking'
    },
    {
        id: 'legendary-gunslinger-mastery',
        name: 'Legendary Gunslinger Mastery',
        description: 'The complete training system that created the fastest gun in the American frontier',
        pattern: 'xcskpb!',
        reps: 39,
        sets: 4,
        focus: 'Fastest Gun'
    }
];

// Main Explorers & Adventurous Souls trainers data object - Group Four
const historyFourTrainersData = {
    'marco-polo': {
        id: 'marco-polo',
        name: 'Marco Polo',
        specialization: 'Silk Road Endurance & Cultural Bridge Building',
        image: '/assets/images/marco-polo.jpg',
        experience: '69+ years',
        category: 'explorers-adventurers',
        color: '#B8860B',
        secondaryColor: '#DAA520',
        intro: `The Venetian merchant who opened the Silk Road and spent 24 years in the court of Kublai Khan. His training develops the endurance needed for multi-year expeditions and the cultural adaptability to thrive in foreign civilizations. Adventure lies beyond the horizon.`,
        programs: marcoPoloPrograms
    },
    'christopher-columbus': {
        id: 'christopher-columbus',
        name: 'Christopher Columbus',
        specialization: 'Ocean Navigation & New World Discovery',
        image: '/assets/images/christopher-columbus.jpg',
        experience: '54+ years',
        category: 'explorers-adventurers',
        color: '#4682B4',
        secondaryColor: '#006994',
        intro: `The Genoese navigator who dared to sail west into the unknown Atlantic and discovered a new hemisphere. His training builds the courage to venture into uncharted waters and the determination to pursue impossible dreams until they become reality.`,
        programs: christopherColumbusPrograms
    },
    'lewis-clark': {
        id: 'lewis-clark',
        name: 'Lewis & Clark',
        specialization: 'Continental Expedition & Wilderness Mapping',
        image: '/assets/images/lewis-clark.jpg',
        experience: '50+ years',
        category: 'explorers-adventurers',
        color: '#8B4513',
        secondaryColor: '#A0522D',
        intro: `The expedition partners who mapped the American wilderness from Missouri to the Pacific Ocean. Their training develops teamwork, diplomatic skills with native peoples, and the perseverance to cross an entire continent through virgin territory.`,
        programs: lewisClarkPrograms
    },
    'ernest-shackleton': {
        id: 'ernest-shackleton',
        name: 'Ernest Shackleton',
        specialization: 'Antarctic Survival & Crisis Leadership',
        image: '/assets/images/ernest-shackleton.jpg',
        experience: '47+ years',
        category: 'explorers-adventurers',
        color: '#B0C4DE',
        secondaryColor: '#E6E6FA',
        intro: `The Antarctic explorer who saved every member of his crew when the Endurance was crushed in pack ice. His training develops unbreakable leadership under impossible conditions and the ability to maintain hope when all seems lost.`,
        programs: ernestShackletonPrograms
    },
    'amelia-earhart': {
        id: 'amelia-earhart',
        name: 'Amelia Earhart',
        specialization: 'Aviation Pioneer & Gender Barrier Breaking',
        image: '/assets/images/amelia-earhart.jpg',
        experience: '39+ years',
        category: 'explorers-adventurers',
        color: '#FFC0CB',
        secondaryColor: '#DDA0DD',
        intro: `The aviation pioneer who shattered gender barriers and inspired women to reach for the skies. Her training develops the courage to be first, the skill to excel in male-dominated fields, and the vision to see possibilities others cannot imagine.`,
        programs: ameliaEarhartPrograms
    },
    'wild-bill-hickok': {
        id: 'wild-bill-hickok',
        name: 'Wild Bill Hickok',
        specialization: 'Frontier Justice & Lightning Reflexes',
        image: '/assets/images/wild-bill-hickok.jpg',
        experience: '39+ years',
        category: 'explorers-adventurers',
        color: '#A0522D',
        secondaryColor: '#8B4513',
        intro: `The legendary gunfighter and lawman who brought justice to the wildest frontier towns. His training develops lightning-fast reflexes, steady nerves under pressure, and the courage to face danger when civilization depends on your quick draw.`,
        programs: wildBillHickokPrograms
    }
};

// Export the data
export default historyFourTrainersData;